import React, { useState } from 'react';
import { get } from 'lodash';
import { Button, Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import deleteIcon from 'images/delete-icon.svg';
import { translate } from 'containers/services/translate';
import RejectTransactionDialog from 'containers/TransactionManagerTimeLine/Transaction/RejectTransactionDialog';
import { StyledSecondaryButton } from 'containers/TransactionManagerTimeLine/VictimInfo/styles';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import { TRANSACTION_STATUS } from 'containers/TransactionManagerTimeLine/constants';
import { TransactionType } from 'typings/globalTypes';
export interface RejectTransactionProps {
  intl: IntlShape;
  requestRejectTransaction: Function;
  transactionInfo: TransactionType;
}
const RejectTransaction: React.FC<RejectTransactionProps> = (
  props,
): JSX.Element => {
  const [openDialogReject, setOpenDialogReject] = useState(false);
  const handleOpenDialog = () => {
    setOpenDialogReject(true);
  };
  const handleCloseDialog = () => {
    setOpenDialogReject(false);
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Button
        style={{ ...(StyledSecondaryButton as any) }}
        data-testId={'reject-transaction-button'}
        onClick={handleOpenDialog}
      >
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <img src={deleteIcon} style={{ marginTop: '4px' }} alt="delete" />
          </Grid>
          <Grid item>
            <span>
              {get(props.transactionInfo, 'transactionStatus.title', null) ===
              TRANSACTION_STATUS.UNSUCCESSFUL_TRANSACTION
                ? translate(messages.rejectTransaction, props)
                : translate(messages.cancelRejectTransaction, props)}
            </span>
          </Grid>
        </Grid>
      </Button>
      <RejectTransactionDialog
        open={openDialogReject}
        handleClose={handleCloseDialog}
        requestRejectTransaction={props.requestRejectTransaction}
        transactionInfo={props.transactionInfo}
      />
    </div>
  );
};
export default injectIntl(RejectTransaction);
